import { all, takeLatest } from "redux-saga/effects";
import { deck, hand, game, playerVote } from "./modules";
import * as playerModule from "./modules/player";
import * as playerFeedbackModule from "./modules/player-feedback";

import playerParticipation from "./modules/player-participation";
import { gameNoteActions } from "./modules/game-notes/actions";
import { gameNoteSagas } from "./modules/game-notes/sagas";
import { actions as topikActions, sagas as topikSagas } from "./modules/topik";

export function* sagas() {
  yield all([
    takeLatest(hand.actions.deal.request, hand.sagas.deck.deal),
    takeLatest(hand.actions.play.request, hand.sagas.play.post),
    takeLatest(hand.actions.play.undo.request, hand.sagas.play.undo),
    takeLatest(hand.actions.played.request, hand.sagas.played.get),
    takeLatest(deck.actions.get.request, deck.sagas.deck.get),
    takeLatest(game.actions.get.request, game.sagas.game.get),
    takeLatest(game.actions.restore.request, game.sagas.game.restore),
    takeLatest(game.actions.join.submit, game.sagas.game.join),
    takeLatest(game.actions.rejoin.submit, game.sagas.game.rejoin),
    takeLatest(game.actions.finish.request, game.sagas.game.finish),
    takeLatest(playerModule.actions.get.request, playerModule.sagas.player.get),
    takeLatest(playerModule.actions.patch.request, playerModule.sagas.player.patch),
    takeLatest(playerVote.actions.vote.request, playerVote.sagas.votes.post),
    takeLatest(playerFeedbackModule.actions.get.request, playerFeedbackModule.sagas.playerFeedback.get),
    takeLatest(playerFeedbackModule.actions.post.request, playerFeedbackModule.sagas.playerFeedback.post),

    takeLatest(gameNoteActions.post.request, gameNoteSagas.post),

    takeLatest(
      playerParticipation.actions.idea.post.request,
      playerParticipation.sagas.idea.post,
    ),

    takeLatest(
      playerParticipation.actions.idea.delete.request,
      playerParticipation.sagas.idea.delete,
    ),

    takeLatest(
      playerParticipation.actions.idea.upvote.request,
      playerParticipation.sagas.idea.upvote,
    ),

    takeLatest(topikActions.session.get.request, topikSagas.getSession),
    takeLatest(topikActions.comparisons.generality.request, topikSagas.comparisonGenerality),
    takeLatest(topikActions.comparisons.outcome.request, topikSagas.comparisonOutcome),
    takeLatest(topikActions.analysis.observation.request, topikSagas.analysisObservation),
    takeLatest(topikActions.analysis.seriousness.request, topikSagas.analysisSeriousness),
    takeLatest(topikActions.analysis.issues.request, topikSagas.analysisIssues),
    takeLatest(topikActions.analysis.risk.request, topikSagas.analysisRisk),
    takeLatest(topikActions.analysis.solution.request, topikSagas.analysisSolution),
    takeLatest(topikActions.analysis.continue.request, topikSagas.analysisContinue),
    takeLatest(topikActions.analysis.riskMitigation.request, topikSagas.analysisRiskMitigation),
    takeLatest(
      topikActions.analysis.solutionMaximizer.request, topikSagas.analysisSolutionMaximizer,
    ),
    takeLatest(topikActions.analysis.goal.request, topikSagas.analysisGoal),
    takeLatest(topikActions.analysis.back.request, topikSagas.analysisBack),
    takeLatest(topikActions.aiAssist.request.request, topikSagas.aiAssistRequest),
    takeLatest(topikActions.aiAssist.restore, topikSagas.aiAssistRestore),

    game.sagas.pollDriver(),
  ]);
}
